import React from 'react';
import { format } from 'date-fns';
import styled from 'styled-components';

import { TourStopAddToTourModal } from 'api/TourController/getTours';
import { buildItemCountText } from '../../Router/pages/TourEditPage/utils';
import { Text, theme, Title } from '../../components';

export type TourSummaryProps = {
  id: string; // not needed for now
  name: string;
  date: Date;
  stops: TourStopAddToTourModal[];
};

const TourSummary: React.FC<TourSummaryProps> = ({ id, name, date, stops }) => {
  const [startTime, setStartTime] = React.useState<Date | undefined>();
  const [endTime, setEndTime] = React.useState<Date | undefined>();
  React.useEffect(() => {
    let newStartTime: Date | undefined;
    let newEndTime: Date | undefined;
    stops.forEach(
      ({
        status,
        time,
        timeEnd,
        originalTime,
        originalTimeEnd,
        listingContactTimeChange,
      }) => {
        let itemStartTime;
        let itemEndTime;
        if (status === 'suggested_time_change' || status === 'time_change') {
          itemStartTime = originalTime;
          itemEndTime = originalTimeEnd;
        } else {
          itemStartTime = time;
          itemEndTime = timeEnd;
        }
        if (!newStartTime || +itemStartTime < +newStartTime)
          newStartTime = itemStartTime;
        if (!newEndTime || +itemEndTime > +newEndTime) newEndTime = itemEndTime;
      },
    );

    setStartTime(newStartTime);
    setEndTime(newEndTime);
  }, [id, name, date, stops]);

  return (
    <StyledTourSummary>
      <Title level={3}>{name}</Title>
      <Text block type={'secondary'}>
        {format(date, 'MMM d, yyyy')}
      </Text>
      <Text block type={'secondary'}>
        {!startTime
          ? 'No times selected'
          : `${format(startTime, 'h:mmaaa')} - ${format(endTime, 'h:mmaaa')}`}
        {` • ${buildItemCountText(stops.length)}`}
      </Text>
    </StyledTourSummary>
  );
};

export default TourSummary;

const StyledTourSummary = styled.div`
  ${Title} {
    margin-bottom: 0px;
  }
  ${Title} + ${Text} {
    font-weight: normal;
    color: ${theme.gray8};
  }
  ${Text} + ${Text} {
    font-weight: normal;
  }
`;
